import { render, staticRenderFns } from "./ControlOfYourWellbeing.vue?vue&type=template&id=624bfdc0&"
import script from "./ControlOfYourWellbeing.vue?vue&type=script&lang=js&"
export * from "./ControlOfYourWellbeing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports